import React from 'react'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import masterServices from '../../Services/masterService'
 
export function CommercialDetails() {
    const history = useHistory()
    const [data,] = useState(history.location.state)
    const [isDetailOpen, setIsDetailOpen] = useState([])
    let param = new URLSearchParams(history.location.search)
    useEffect(() => {
        onDetail()
    }, [])

    const onDetail = () => {
        let postData = {
            id: param.get('id')
        }
        masterServices.get_commercial_details(postData).then(res => {
            if (res.status) {
                setIsDetailOpen(res.data)
            }
        })
    }

    return (

        <div className="container-fluid">          
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card p-3">

                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 border-end">

                                            {/* <h5 className="secHeading">Sender Details</h5> */}
                                            <table width="100%">
                                                <tbody>
                                                    <tr>

                                                        <td className="py-1"> name - </td>
                                                        <td className="py-1"> {data && data.commercial_name}</td>
                                                    </tr>

                                                    <tr>
                                                        <td className="py-1">Contact Person - </td>
                                                        <td className="py-1">{data && data.contact_person}r</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Contact No. - </td>
                                                        <td className="py-1">{data && data.phone_number}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Email - </td>
                                                        <td className="py-1">{data && data.commercial_email}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="col-lg-6 col-md-6 border-end">
                                            {/* <h5 className="secHeading">Receiver Details</h5> */}
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1"> Registered Address- </td>
                                                        <td className="py-1">{data && data.address}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Taxation Details - </td>
                                                        <td className="py-1">{data && data.taxation_details}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Total Discount - </td>
                                                        <td className="py-1">{data && data.total_discount}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />

                </div>
            </div>
        </div>

    )
}

